document.addEventListener("DOMContentLoaded", () => {
    const allSearchForms = document.querySelectorAll('[data-guide-search-id]');
    if (allSearchForms.length === 0) {
        return;
    }
    const questions = window.questions || [];

    const synonymMap = {
        zmarl: "smierc",
        umarl: "smierc",
        smuerc: "smierc",
        auto: "pojazd",
        dom: "budowa",
    };

    const bannedPairs = {
        smiec: ["smierc"],
        smier: ["smiec"],
        smierc: ["smiec"],
    };

    const searchableData = questions.map((question) => ({
        original: question,
        normalizedText: normalizeText(question.text),
        normalizedKeywords: (question.keywords || []).map(normalizeText),
        normalizedHiddenKeywords: (question.hidden_keywords || []).map(normalizeText),
    }));

    const baseFuseOptions = {
        includeScore: true,
        shouldSort: true,
        minMatchCharLength: 3,
        distance: 1000,
    };

    const fusePrimary = new Fuse(searchableData, {
        ...baseFuseOptions,
        threshold: 0.3,
        keys: [
            { name: "normalizedText", weight: 0.7 },
            { name: "normalizedKeywords", weight: 0.3 }
        ],
    });

    const fuseAll = new Fuse(searchableData, {
        ...baseFuseOptions,
        threshold: 0.4,
        keys: [
            { name: "normalizedText", weight: 0.6 },
            { name: "normalizedKeywords", weight: 0.3 },
            { name: "normalizedHiddenKeywords", weight: 0.1 }
        ],
    });

    function normalizeText(text) {
        if (!text) return "";
        return text
            .toLowerCase()
            .replace(/ą/g, "a").replace(/ć/g, "c").replace(/ę/g, "e")
            .replace(/ł/g, "l").replace(/ń/g, "n").replace(/ó/g, "o")
            .replace(/ś/g, "s").replace(/ź/g, "z").replace(/ż/g, "z")
            .replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, "");
    }

    function processQuery(query) {
        const normalized = normalizeText(query);
        const words = normalized.split(/\s+/);
        return words
            .map(word => synonymMap[word] || word)
            .filter(word => word.length > 2)
            .join(" ");
    }

    function highlightText(text, query) {
        if (!query || !text) return text;
        const queryWords = query.split(" ").filter((word) => word.length > 0);
        const diacriticsMap = { a: "[aą]", c: "[cć]", e: "[eę]", l: "[lł]", n: "[nń]", o: "[oó]", s: "[sś]", z: "[zźż]" };
        let highlightedText = text;
        queryWords.forEach((word) => {
            let regexString = "";
            for (const char of normalizeText(word)) {
                regexString += diacriticsMap[char] || char.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
            }
            const regex = new RegExp(`(${regexString})`, "gi");
            highlightedText = highlightedText.replace(regex, `<span class="highlight">${'$1'}</span>`);
        });
        return highlightedText;
    }

    allSearchForms.forEach(searchForm => {
        const searchInput = searchForm.querySelector('input[type="search"]');
        const resultsContainer = searchForm.querySelector('[data-guide-results-id]');
        const location = searchForm.dataset.location;

        if (location === 'hidden') {
            const pageResultsContainer = document.getElementById('search-page-results-container');
            if (!pageResultsContainer) return;

            const params = new URLSearchParams(window.location.search);
            const queryFromUrl = params.get('q');

            if (queryFromUrl) {
                searchInput.value = queryFromUrl;
                const cleanedQuery = processQuery(queryFromUrl);

                let primaryResults = fusePrimary.search(cleanedQuery);
                const queryWords = cleanedQuery.split(' ');
                const bannedWordsForQuery = queryWords.reduce((acc, word) => {
                    if (bannedPairs[word]) return [...acc, ...bannedPairs[word]];
                    return acc;
                }, []);

                if (bannedWordsForQuery.length > 0) {
                    primaryResults = primaryResults.filter((result) => {
                        const textToCheck = [result.item.normalizedText, ...result.item.normalizedKeywords].join(" ");
                        return !bannedWordsForQuery.some((bannedWord) => textToCheck.includes(bannedWord));
                    });
                }

                const primaryResultIds = new Set(primaryResults.map((r) => r.item.original.id));
                const allResults = fuseAll.search(cleanedQuery);
                let suggestionResults = allResults.filter((r) => !primaryResultIds.has(r.item.original.id));
                const uniqueSuggestionIds = new Set();
                suggestionResults = suggestionResults.filter((r) => {
                    const id = r.item.original.id;
                    if (uniqueSuggestionIds.has(id)) return false;
                    uniqueSuggestionIds.add(id);
                    return true;
                });
                const totalResults = primaryResults.length + suggestionResults.length;

                let html = `<h2>Znaleziono wyników: <b>${totalResults}</b> dla frazy: <b>"${queryFromUrl}"</b></h2>`;

                if (totalResults === 0) {
                    html += `<p>Brak wyników dla podanej frazy.</p>`;
                } else {
                    if (primaryResults.length > 0) {
                        html += `<ul class="search-results-list">`;
                        primaryResults.forEach(result => {
                            const item = result.item.original;
                            const titleHtml = highlightText(item.text, cleanedQuery);
                            html += `<li class="search-results-item"><a href="pytanie/${item.alias}">${titleHtml}</a></li>`;
                        });
                        html += `</ul>`;
                    }
                    if (suggestionResults.length > 0) {
                        html += `<div class="search-page-suggestions"><h2>Czy może chodziło Ci o:</h2><ul class="search-results-list">`;
                        suggestionResults.forEach(result => {
                            const item = result.item.original;
                            const titleHtml = highlightText(item.text, cleanedQuery);
                            let keywordsHtml = '';
                            // if (item.keywords && item.keywords.length > 0) {
                            //     keywordsHtml = `<small class="search-results-keywords">Słowa kluczowe: <i>${item.keywords.join(', ')}</i></small>`;
                            // }
                            html += `<li class="search-results-item"><a href="pytanie/${item.alias}">${titleHtml}${keywordsHtml}</a></li>`;
                        });
                        html += `</ul></div>`;
                    }
                }
                pageResultsContainer.innerHTML = html;
            }

        } else {
            const params = new URLSearchParams(window.location.search);
            const queryFromUrl = params.get('q');
            if (queryFromUrl) {
                searchInput.value = decodeURIComponent(queryFromUrl.replace(/\+/g, ' '));
            }

            searchForm.addEventListener('submit', (event) => {
                event.preventDefault();
                const query = searchInput.value.trim();
                if (query) {
                    window.location.href = `wyniki-wyszukiwania?q=${encodeURIComponent(query)}`;
                }
            });

            searchInput.addEventListener("input", () => handleInteractiveSearch(searchInput, resultsContainer, location));

            document.addEventListener("click", (e) => {
                if (e.target !== searchInput && !resultsContainer.contains(e.target)) {
                    resultsContainer.style.display = "none";
                }
            });

            document.addEventListener("keydown", (e) => {
                const focusableItems = Array.from(resultsContainer.querySelectorAll(".c-guideSearch__hintstLink"));
                if (resultsContainer.style.display !== 'block' || focusableItems.length === 0) return;
                const currentIndex = focusableItems.indexOf(document.activeElement);

                if (e.key === "ArrowDown") {
                    e.preventDefault();
                    focusableItems[(currentIndex + 1) % focusableItems.length].focus();
                } else if (e.key === "ArrowUp") {
                    e.preventDefault();
                    if (currentIndex <= 0) searchInput.focus();
                    else focusableItems[(currentIndex - 1 + focusableItems.length) % focusableItems.length].focus();
                } else if (e.key === "Escape") {
                    resultsContainer.style.display = "none";
                }
            });

            if (location === "hero") {
                setupHeroAnimation(searchInput);
            } else {
                if (!searchInput.value) {
                    searchInput.placeholder = "Wpisz czego szukasz";
                }
            }
            renderPromotedQuestions();
        }
    });

    function handleInteractiveSearch(input, container, location) {
        const rawQuery = input.value.trim();
        container.style.display = rawQuery ? "block" : "none";

        const isRawQueryEmpty = !rawQuery;

        if (location === "header") {
            const headerNav = document.querySelector(".c-mainHeader__mainNav");
            
            if(!isRawQueryEmpty && headerNav.dataset.shouldHideOnScroll === "true") {
                const mobileNav = document.querySelector(".c-mainHeader__mobileNav");
                
                headerNav.classList.remove("c-mainHeader__mainNav--hidden");
                mobileNav.classList.remove("c-mainHeader__mobileNav--hidden");
            }

            headerNav.dataset.shouldHideOnScroll = isRawQueryEmpty;
        }

        if (isRawQueryEmpty) {
            container.innerHTML = "";
            return;
        }

        const cleanedQuery = processQuery(rawQuery);
        if (!cleanedQuery) {
            displayDropdownResults(container, [], [], rawQuery, "");
            return;
        }

        let primaryResults = fusePrimary.search(cleanedQuery);

        const queryWords = cleanedQuery.split(' ');
        const bannedWordsForQuery = queryWords.reduce((acc, word) => {
            if (bannedPairs[word]) return [...acc, ...bannedPairs[word]];
            return acc;
        }, []);

        if (bannedWordsForQuery.length > 0) {
            primaryResults = primaryResults.filter((result) => {
                const textToCheck = [result.item.normalizedText, ...result.item.normalizedKeywords].join(" ");
                return !bannedWordsForQuery.some((bannedWord) => textToCheck.includes(bannedWord));
            });
        }

        const primaryResultIds = new Set(primaryResults.map((r) => r.item.original.id));
        const allResults = fuseAll.search(cleanedQuery);

        let suggestionResults = allResults.filter((r) => !primaryResultIds.has(r.item.original.id));

        const uniqueSuggestionIds = new Set();
        suggestionResults = suggestionResults.filter((r) => {
            const id = r.item.original.id;
            if (uniqueSuggestionIds.has(id)) return false;
            uniqueSuggestionIds.add(id);
            return true;
        });

        displayDropdownResults(container, primaryResults.slice(0, 5), suggestionResults.slice(0, 3), rawQuery, cleanedQuery);
    }

    function displayDropdownResults(container, primaryResults, suggestionResults, originalQuery, cleanedQuery) {
        container.innerHTML = "";
        if (originalQuery.length < 3 && primaryResults.length === 0 && suggestionResults.length === 0) {
            container.innerHTML = `<p class="c-guideSearch__searchInfo text-gray-500 text-center">Wprowadź minimum 3 litery</p>`;
            return;
        } else if (originalQuery.length >= 3 && primaryResults.length === 0 && suggestionResults.length === 0) {
            container.innerHTML = `<p class="c-guideSearch__searchInfo text-gray-500 text-center">Brak wyników dla frazy "${originalQuery}"</p>`;
            return;
        }

        const renderPrimaryList = (results) => {
            return results.map((result) => {
                const item = result.item.original;
                const titleHtml = highlightText(item.text, cleanedQuery);
                return `<li class="c-guideSearch__hintstItem"><a href="pytanie/${item.alias}" class="c-guideSearch__hintstLink"><p class="c-guideSearch__hintstTitle">${titleHtml}</p></a></li>`;
            }).join("");
        };

        const renderSuggestionList = (results) => {
            return results.map((result) => {
                const item = result.item.original;
                const titleHtml = highlightText(item.text, cleanedQuery);
                let keywordsHtml = '';
                // if (item.keywords && item.keywords.length > 0) {
                //     keywordsHtml = `<small class="search-results-keywords">Słowa kluczowe: <i>${item.keywords.join(', ')}</i></small>`;
                // }
                return `<li class="c-guideSearch__hintstItem"><a href="pytanie/${item.alias}" class="c-guideSearch__hintstLink"><p class="c-guideSearch__hintstTitle">${titleHtml}</p>${keywordsHtml}</a></li>`;
            }).join("");
        };

        let html = "";
        if (primaryResults.length > 0) {
            html += `<ul class="c-guideSearch__hintstBox">${renderPrimaryList(primaryResults)}</ul>`;
        }
        if (suggestionResults.length > 0) {
            html += `<div class="c-guideSearch__suggestions"><h4>Czy może chodziło Ci o:</h4><ul class="c-guideSearch__hintstBox">${renderSuggestionList(suggestionResults)}</ul></div>`;
        }
        container.innerHTML = html;
    }

    function setupHeroAnimation(input) {
        if (input.value) return;

        const placeholderTexts = [
            "jak zarejestrować pojazd?",
            "gdzie wyrobić dowód?",
            "jak zgłosić awarię prądu?",
            "jak wymienić prawo jazdy?",
            "gdzie zgłosić śmieci w parku?",
        ];

        let textIndex = 0, charIndex = 0, isDeleting = false, animationTimeout;
        const typingSpeed = 120, deletingSpeed = 70, delayBetweenTexts = 2500;

        function typeAnimation() {
            const currentText = placeholderTexts[textIndex];
            charIndex += isDeleting ? -1 : 1;
            input.placeholder = `np. ${currentText.substring(0, charIndex)}`;

            if (!isDeleting && charIndex === currentText.length) {
                isDeleting = true;
                animationTimeout = setTimeout(typeAnimation, delayBetweenTexts);
            } else if (isDeleting && charIndex === 0) {
                isDeleting = false;
                textIndex = (textIndex + 1) % placeholderTexts.length;
                animationTimeout = setTimeout(typeAnimation, 500);
            } else {
                animationTimeout = setTimeout(typeAnimation, isDeleting ? deletingSpeed : typingSpeed);
            }
        }

        input.addEventListener("focus", () => clearTimeout(animationTimeout));
        input.addEventListener("blur", () => {
            if(input.value.trim() === "") typeAnimation();
        });
        typeAnimation();
    }

    function renderPromotedQuestions() {
        const randomQuestions = window.randomQuestions || [];
        if (randomQuestions.length === 0) return;
        const container = document.getElementById('popularSearches');
        if (!container) return;

        let html = '<ul class="c-guideSearch__list">';
        randomQuestions.forEach(question => {
            html += `<li><a href="pytanie/${question.alias}" class="c-guideSearch__link">${question.short_title}</a></li>`;
        });
        html += '</ul>';
        container.innerHTML = html;

        const list = container.querySelector('ul');
        const items = Array.from(list.children);
        if (items.length === 0) return;

        let previousTop = items[0].offsetTop;
        let lines = 1;

        items.forEach(item => {
            if (item.offsetTop > previousTop) {
                lines++;
                previousTop = item.offsetTop;
            }
            if (lines > 2) {
                item.remove();
            }
        });
    }

});
